import React, { useState } from "react";
import Button from "@material-ui/core/Button";
import DialogActions from "@material-ui/core/DialogActions";
import axios from "axios";

export default function ProjectPhaseDeleteDialog({ phase = null, onClose = () => { }, onSuccess = () => { }, onDialogClose = () => { } }) {
    const [loading, setLoading] = useState(false);

    const handleDelete = async () => {
        if (!phase?.privateId) return;

        setLoading(true);
        try {
            await axios.delete(`/api/projectphase/${phase.privateId}`);
            // Dispatch event to refresh project detail
            window.dispatchEvent(new CustomEvent("projectphase:deleted", { detail: { privateId: phase.privateId } }));
            onSuccess();
        } catch (err) {
            console.error("Failed to delete project phase", err);
        } finally {
            setLoading(false);
            onClose();
        }
    };

    return (
        <>
            <p>Biztos vagy benne, hogy törölni akarod ezt az ütemet?</p>
            <p><strong>{phase?.phaseNumber}. ütem</strong> ({phase?.startDate} — {phase?.endDate})</p>
            <DialogActions>
                <Button onClick={onDialogClose}>Mégse</Button>
                <Button
                    color="secondary"
                    variant="contained"
                    onClick={handleDelete}
                    disabled={loading}
                >
                    Törlés
                </Button>
            </DialogActions>
        </>
    );
}
